import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {API_URLS} from '../config/api.urls';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShippingOfferService {

  constructor(private httpClient: HttpClient) {}

  addShippingOffer(offerId: number, shippingOffer: any): Observable<any> {
    return this.httpClient.post(API_URLS.OFFERS_BASE_URL + '/' + offerId + '/shipping_offers', shippingOffer);
  }

  updateShippingOffer(offerId: number, shippingOffer: any): Observable<any> {
    return this.httpClient.put(API_URLS.OFFERS_BASE_URL + '/' + offerId + '/shipping_offers/' + shippingOffer.id , shippingOffer);
  }

  deleteShippingOffer(offerId: number, shippingOfferId: number): Observable<any> {
    return this.httpClient.delete(API_URLS.OFFERS_BASE_URL + '/' + offerId + '/shipping_offers/' + shippingOfferId);
  }
}
